<template>
  <div class="dice-btn" @click="openModal"></div>
</template>

<script>
export default {
  name: "DiceComponent",
  methods: {
    openModal() {
      this.$emit("open-modal"); // Notify parent to open modal
    },
  },
};
</script>

<style scoped>
/* Container for the dice button */
.dice-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-image: url('@/assets/images/dice/dice.png'); /* Your dice image */
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;

  /* Dimensions */

  /* Rounded corners and smooth transition */
  border-radius: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.dice-btn:hover {
  cursor: pointer;
  transform: scale(1.1); /* Slightly enlarge the dice container */
}
</style>
